import { watch } from 'vue';
import { createI18n } from 'vue-i18n';
import { useDeviceStore } from '/src/store/stores/useDeviceStore.js';
import { availableLocales } from '/src/config/locales.js';

const fallbackLocale = {
	'es-MX': ['es-ES'],
	'ca-ES': ['es-ES'],
	default: ['es-ES'],
};

// i18n
const i18n = createI18n({
	legacy: false,
	globalInjection: true,
	fallbackLocale,
});

// Initialize locale after store is available
export function initLocale () {
	const { locale } = useDeviceStore();

	updateLocale(locale.value);

	// watch locale changes
	watch(locale, (newLocale) => {
		console.log('🌍 [locale] watch', newLocale);
		updateLocale(newLocale);
	});
}

export async function updateLocale (code) {
	const file = availableLocales.find(locale => locale.code === code)?.file;
	const messages = await import(`./messages/${file}.json`);

	i18n.global.setLocaleMessage(code, messages.default);
	i18n.global.locale.value = code;
}

export default i18n;
